import { useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="relative z-10 border-t border-white/5 backdrop-blur-md mt-20">
      <div className="max-w-7xl mx-auto px-6 py-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="min-w-0">
            <div className="flex flex-wrap items-center gap-3 mb-4">
              <img src="/logo192.png" alt="TradeInsights logo" className="w-8 h-8 rounded-lg shrink-0" data-testid="footer-logo" />
              <span className="text-base font-bold text-white break-words" style={{ fontFamily: 'Unbounded' }}>
                TRADEINSIGHTS
              </span>
            </div>
            <p className="text-sm text-gray-400">
              AI-powered market intelligence for smarter trading decisions.
            </p>
          </div>

          {/* Product */}
          <div>
            <h3 className="text-white font-semibold mb-4">Product</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <button 
                  onClick={() => navigate('/dashboard')} 
                  className="text-gray-400 hover:text-[#00E0FF] transition-colors"
                >
                  Dashboard
                </button>
              </li>
              <li>
                <button 
                  onClick={() => navigate('/portfolio')} 
                  className="text-gray-400 hover:text-[#00E0FF] transition-colors"
                >
                  Portfolio
                </button>
              </li>
              <li>
                <button 
                  onClick={() => navigate('/learning')} 
                  className="text-gray-400 hover:text-[#00E0FF] transition-colors"
                >
                  Learning Hub
                </button>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold mb-4">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <button 
                  data-testid="footer-terms-link"
                  onClick={() => navigate('/terms')} 
                  className="text-gray-400 hover:text-[#00E0FF] transition-colors"
                >
                  Terms of Service
                </button>
              </li>
              <li>
                <button 
                  data-testid="footer-privacy-link"
                  onClick={() => navigate('/privacy')} 
                  className="text-gray-400 hover:text-[#00E0FF] transition-colors"
                >
                  Privacy Policy
                </button>
              </li>
              <li>
                <button 
                  data-testid="footer-disclaimer-link"
                  onClick={() => navigate('/disclaimer')} 
                  className="text-gray-400 hover:text-[#00E0FF] transition-colors"
                >
                  Risk Disclaimer
                </button>
              </li>
            </ul>
          </div>

          {/* Disclaimer Notice */}
          <div>
            <h3 className="text-white font-semibold mb-4">Important</h3>
            <p className="text-xs text-gray-500 leading-relaxed">
              <span className="text-[#F59E0B] font-semibold">⚠️ Risk Warning:</span> Trading involves substantial risk. Our predictions are not financial advice. Past performance does not guarantee future results.
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 border-t border-white/5">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-gray-500">
              © 2026 TradeInsights. All rights reserved.
            </p>
            <p className="text-xs text-gray-600">
              Not affiliated with any financial institution. For educational purposes only.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
